import { Maybe } from '../types';
import { messageOfUnknownError } from '../utils/utils';

export function pickMessage(message: Maybe<string>, error: unknown) {
  return message ? message : messageOfUnknownError(error);
}

export default class PaymentError extends Error {
  public retryable = false;
  public originalMessage?: string = undefined;
  constructor({
    message,
    retryable,
    error,
  }: {
    message?: string;
    retryable?: boolean;
    error?: unknown;
  }) {
    super(pickMessage(message, error));
    if (error instanceof Error) {
      this.stack = error.stack;
      this.originalMessage = error.message;
    }
    this.retryable = !!retryable;
    Object.setPrototypeOf(this, PaymentError.prototype);
  }
}
